<template>
  <div class="postDetail">
    <!--顶部图片商品详情图片-->
    <div class="detailImgs">
      <swiper :options="swiperOption">
        <!-- slides -->
        <swiper-slide v-for="(item,index) in banner" :key="index">
          <img :src="item" alt />
        </swiper-slide>
        <section class="swiper-pagination" slot="pagination"></section>
      </swiper>
    </div>
    <!-- 帖子发布 -->
    <div class="postMsg">
      <!-- 发帖人信息 -->
      <div class="people">
        <div class="imgBox">
          <img v-if="avatar" :src="avatar" alt />
          <img v-else src="../assets/ic_default_avatar.png" alt />
        </div>
        <div class="nameBox">
          <div class="name">{{nickname}}</div>
          <div class="time">{{createdTime}}</div>
        </div>
      </div>
      <!-- 发帖标题 -->
      <div class="postTitle">{{title}}</div>
      <!-- 发帖内容 -->
      <div class="postContent">{{content}}</div>
    </div>
    <!-- 留言 -->
    <div class="leaveMessage">
      <div class="title">留言</div>
      <!-- 留言列表 -->
      <div class="messageBox">
        <div class="messageList" v-for="(item,index) in messageDtos" :key="index">
          <div class="left">
            <img v-if="item.avatar" :src="item.avatar" alt />
            <img v-else src="../assets/ic_default_avatar.png" alt />
            <div class="text">
              <div class="top">
                <div class="name">{{item.nickname}}</div>
                <div class="time">{{item.createdTime}}</div>
              </div>
              <div class="content">{{item.content}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 下载按钮 -->
    <div class="downloadBox">
      <div class="download" @click="toInviteFriends">下载家佳宝查看更多精彩内容</div>
    </div>
  </div>
</template>


<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { Indicator, Toast, Popup } from "mint-ui";
// import 'swiper/dist/css/swiper.css';
export default {
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      id: "",
      swiperOption: {
        //以下配置不懂的，可以去swiper官网看api，链接http://www.swiper.com.cn/api/
        pagination: {
          el: ".swiper-pagination",
          type: "fraction"
        }
      },
      banner: [],
      // 发帖人
      avatar: "",
      nickname: "",
      createdTime: "",
      title: "",
      content: "",
      // 留言
      messageDtos: []
    };
  },
  created() {
    var self = this;
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.getDetail();
    }
  },
  methods: {
    getDetail() {
      Indicator.open();
      //获得用户信息
      this.$api
        .postDetail({
          postId: this.id
        })
        .then(res => {
          console.log(res.data);
          this.banner = JSON.parse(res.data.images);
          this.avatar = res.data.avatar;
          this.nickname = res.data.nickname;
          this.createdTime = res.data.createdTime;
          this.title = res.data.title;
          this.content = res.data.content;
          this.messageDtos = res.data.messageDtos;
          Indicator.close();
          // if (window.WeixinJSBridge && WeixinJSBridge.invoke) {
            this.$wxShare.wxShare({}, location.href, this.banner[0], this.title).then(res=>{
              console.log(111)
            });
          // }
        });
    },
    toInviteFriends() {
      this.$router.push("inviteFriends");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
/* .swiper-pagination-fraction { */
/* .swiper-pagination-fraction {
  font-size: 0.22rem;
  font-family: DIN Alternate;
  font-weight: bold;
  color: rgba(255, 255, 255, 1);
  display: flex;
  justify-content: center;
  align-items: flex-end;
  align-items: center;
  padding-bottom: 0.052rem;
  letter-spacing: 1.5px;
}
.swiper-pagination-current {
  font-size: 0.28rem;
  line-height: 0.29rem;
} */
/* } */
</style>
<style scoped  lang="scss">
.postDetail {
  width: 100vw;
  min-height: 100vh;
  background: #f6f6f6;
  padding-bottom: 1.85rem;
  //轮播图
  .detailImgs {
    .swiper-container {
      width: 100%;
      height: 7.5rem;
      .swiper-wrapper {
        width: 100%;
        height: 7.5rem;
        // object-fit: cover;
      }
      // 轮播图图片
      img {
        width: 100%;
        height: 100%;
      }
      // 轮播图下标
      .swiper-pagination-fraction,
      .swiper-pagination-custom,
      .swiper-container-horizontal > .swiper-pagination-bullets {
        top: 0.49rem;
        left: 6.62rem;
        width: 0.68rem;
        height: 0.38rem;

        background-color: rgba(
          0,
          0,
          0,
          0.2
        ); /* //注意，是rgba，不是rgb ！！！ */
        border-radius: 0.38rem;
        font-size: 0.23rem;
        // font-family: DIN Alternate;
        font-weight: bold;
        color: rgba(255, 255, 255, 1);
        display: flex;
        justify-content: center;
        align-items: center;
        align-items: center;
        letter-spacing: -1px;
      }
    }
  }
  // 帖子发布
  .postMsg {
    width: 100%;
    background: #fff;
    //发帖人信息
    .people {
      display: flex;
      align-items: center;
      border-bottom: 0.015rem solid #eeeeee;
      padding: 0 0.3rem;
      height: 1.3rem;
      .imgBox {
        width: 0.88rem;
        height: 0.88rem;
        border-radius: 0.88rem;
        background: #ddd;
        overflow: hidden;
        margin-right: 0.25rem;
        img {
          width: 0.88rem;
          height: 0.88rem;
        }
      }
      .nameBox {
        text-align: left;
        .name {
          font-size: 0.3rem;
          font-family: PingFang SC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
        }
        .time {
          margin-top: 0.1rem;
          font-size: 0.2rem;
          font-family: PingFang SC;
          // font-weight: 300;
          color: rgba(136, 136, 136, 1);
        }
      }
    }
    // 发帖标题
    .postTitle {
      text-align: left;
      padding: 0.25rem 0.38rem 0.25rem 0.32rem;
      font-size: 0.36rem;
      font-weight: 400;
      color: rgba(34, 34, 34, 1);
    }
    // 发帖内容
    .postContent {
      text-align: justify;
      padding: 0 0.38rem 0.5rem 0.32rem;
      font-size: 0.28rem;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(34, 34, 34, 1);
      line-height: 0.48rem;
    }
  }
  // 留言
  .leaveMessage {
    margin-top: 0.25rem;
    background: #fff;
    .title {
      text-align: left;
      padding: 0.32rem 0.32rem 0.3rem;
      font-size: 0.32rem;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      border-bottom: 0.015rem solid #eeeeee;
    }
    // 留言列表
    .messageBox {
      padding: 0 0.21rem;
      .messageList {
        display: flex;
        justify-content: space-between;
        padding: 0.3rem 0.1rem 0.3rem 0.09rem;
        border-bottom: 0.015rem solid #eeeeee;
        .left {
          display: flex;
          align-items: flex-start;
          img {
            width: 0.66rem;
            height: 0.66rem;
            margin-right: 0.19rem;
            border-radius: 0.66rem;
          }
          .text {
            text-align: left;
            .top {
              width: 6rem;
              display: flex;
              justify-content: space-between;
              align-items: center;
              .name {
                font-size: 0.3rem;
                font-family: PingFang SC;
                font-weight: 400;
                color: rgba(0, 0, 0, 1);
                line-height: 0.4rem;
              }
              .time {
                font-size: 0.2rem;
                font-family: PingFang SC;
                // font-weight: 300;
                color: rgba(136, 136, 136, 1);
                line-height: 0.4rem;
              }
            }
            .content {
              font-size: 0.26rem;
              font-family: PingFang SC;
              font-weight: 300;
              color: rgba(68, 68, 68, 1);
              line-height: 0.57rem;
            }
          }
        }
      }
      .messageList:last-child {
        border-bottom: none;
      }
    }
  }
  // 下载按钮
  .downloadBox {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 1.6rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    .download {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 6.6rem;
      height: 0.9rem;
      border-radius: 0.9rem;
      background: #fe5198;
      font-size: 0.34rem;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/postDetail.vue